//angular
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
//app modules
import { AppMaterialModule } from '../../../app.material';
import { AppSharedModule } from 'src/app/_shared/app.shared.module';
import { SharedModule } from '../_shared/shared.module';
//app routing
import { SettingsRoutingModule } from './settings.routing';
//app services
import { AuthGuardService } from '../../../_guard/auth.guard';
import { SettingsService } from './_services/api/settings.service';
import { CrossServiceModule } from 'src/app/_core/services/api/cross-service.module';

const COMPONENTS: any[] = []

const DIALOGS: any[] = []

const MODULES: any[] = [
  AppMaterialModule,
  AppSharedModule,
  CommonModule,
  CrossServiceModule,
  FormsModule,
  ReactiveFormsModule,
  SettingsRoutingModule,
  SharedModule
]

const PROVIDERS: any[] =[
  AuthGuardService,
  SettingsService
]

@NgModule({
  declarations: [ COMPONENTS, DIALOGS ],
  imports: [ MODULES ],
  providers: [ PROVIDERS ]
})

export class SettingsModule {
  constructor() {
    console.log(`settings.module.ts was loaded.`)
  }
}
